export function StyleSimplifier (pEditor, pStyle)
{
  this.simplifyFormatting = (content, args = {}) =>
  {
    let i, n,
        prevContent,
        isSimplify = false,
        elements,
        element,
        retElement,
        nodeName,
        attrs,
        attrName,
        styleRule,
        styleTrans,
        saveTrueStyles = [],
        styleTagsBegin,
        styleTagsEnd,
        reEmptyOrSpaces = /\S/,

        trueTags = args.rules.trueTags,
        reEmptyTags = args.rules.reEmptyTags,
        reEmptyTagsReplace = args.rules.reEmptyTagsReplace,
        trueAttributes = args.rules.trueAttributes,
        trueStyles = args.rules.trueStyles,
        styles2Tags = args.rules.styles2Tags;

    if (!content && content.replace(/\s+/g, '') === '')
    {
      return content || '';
    }

    if (pStyle.normalizer.checkMsHTML(content))
    {
      content = pStyle.normalizer.clearMsHTML(content);
    }

    pEditor.htmlFragment.innerHTML = content;
    elements = (args.isWaContentMarkers ? pEditor.htmlFragment.querySelectorAll(':not([data-wacontent])') : pEditor.htmlFragment.getElementsByTagName('*'));

    for (i = elements.length; i--;)
    {
      element = elements[i];
      nodeName = element.nodeName.toUpperCase();
      saveTrueStyles.splice(0, saveTrueStyles.length);

      if (!trueTags[nodeName])
      {
        element.outerHTML = element.innerHTML;
        isSimplify = true;
        continue;
      }

      if (typeof(trueTags[nodeName]) === 'function')
      {
        retElement = trueTags[nodeName](element);

        if (retElement.isRemove)
        {
          element.outerHTML = element.innerHTML;
        }
        else if (retElement.element)
        {
          element = retElement.element;
        }

        if (retElement.isChange)
        {
          isSimplify = true;
        }

        if (retElement.isNotModify)
        {
          continue;
        }
      }

      if (args.isClearEmptyTags && reEmptyTags.test(element.nodeName) && !reEmptyOrSpaces.test(element.innerHTML))
      {
        if (element.parentNode)
        {
          element.parentNode.removeChild(element);
        }

        continue;
      }

      attrs = element.attributes;

      for (n = attrs.length; n--;)
      {
        attrName = attrs[n].name.toLowerCase();

        if (trueAttributes[attrName] && trueAttributes[attrName].tags.test(nodeName) && attrs[n].value && ((typeof(trueAttributes[attrName].values) === 'function' && trueAttributes[attrName].values(element, attrs[n].value)) || (typeof(trueAttributes[attrName].values) === 'object' && trueAttributes[attrName].values.test(attrs[n].value))))
        {
          if (trueAttributes[attrName].trans)
          {
            trueAttributes[attrName].trans(element, attrs[n]);
            isSimplify = true;
          }
        }
        else if (!(attrName.indexOf('data-') === 0 && trueAttributes['data-']))
        {
          element.removeAttribute(attrs[n].name);
          isSimplify = true;
        }
      }

      styleTagsBegin = '';
      styleTagsEnd = '';

      for (n = 0; n < styles2Tags.length; n++)
      {
        styleRule = element.style[styles2Tags[n].rule];

        if (styleRule)
        {
          if (styles2Tags[n].value.test(styleRule))
          {
            if (styles2Tags[n].trans)
            {
              styles2Tags[n].trans(element, styleRule);
              isSimplify = true;
            }
            else
            {
              styleTagsBegin += '<' + styles2Tags[n].tag + '>';
              styleTagsEnd = '</' + styles2Tags[n].tag + '>' + styleTagsEnd;
            }
          }
        }
      }

      if (styleTagsBegin)
      {
        element.innerHTML = styleTagsBegin + element.innerHTML + styleTagsEnd;
        isSimplify = true;
      }

      if (element.hasAttribute('style'))
      {
        for (n = 0; n < trueStyles.length; n++)
        {
          if (element.style[trueStyles[n].rule] && trueStyles[n].tags.test(nodeName) && trueStyles[n].values.test(element.style[trueStyles[n].rule]))
          {
            if (trueStyles[n].trans)
            {
              styleTrans = trueStyles[n].trans(element, trueStyles[n].rule, element.style[trueStyles[n].rule]);

              if (styleTrans)
              {
                saveTrueStyles.push(
                {
                  'rule': styleTrans.rule,
                  'value': styleTrans.value
                });
              }
            }
            else
            {
              saveTrueStyles.push(
              {
                'rule': trueStyles[n].rule,
                'value': element.style[trueStyles[n].rule]
              });
            }
          }
        }

        element.removeAttribute('style');

        for (n = 0; n < saveTrueStyles.length; n++)
        {
          element.style[saveTrueStyles[n].rule] = saveTrueStyles[n].value;
        }

        isSimplify = true;
      }

      if (args.isWaContentMarkers)
      {
        element.setAttribute('data-wacontent', pEditor.waContentMarkerCounter++);
        element.setAttribute('data-wacontenttag', element.tagName);
      }
    }

    elements = pEditor.htmlFragment.getElementsByTagName('SPAN');

    for (i = elements.length; i--;)
    {
      element = elements[i];

      if (element.attributes.length === 0 || (element.attributes.length === 1 && element.hasAttribute('data-wacontent')))
      {
        element.outerHTML = element.innerHTML;
        isSimplify = true;
      }
    }

    elements = pEditor.htmlFragment.getElementsByTagName('FONT');

    for (i = elements.length; i--;)
    {
      element = elements[i];

      if (element.attributes.length === 0 || (element.attributes.length === 1 && element.hasAttribute('data-wacontent')))
      {
        element.outerHTML = element.innerHTML;
        isSimplify = true;
      }
      else if (element.nodeName === 'FONT' && element.parentNode.nodeName === 'FONT' && element.parentNode.innerHTML === element.outerHTML)
      {
        attrs = element.parentNode.attributes;

        for (n = 0; n < attrs.length; n++)
        {
          if (!element.hasAttribute(attrs[n].name))
          {
            element.setAttribute(attrs[n].name, attrs[n].value);
          }
        }

        element.parentNode.outerHTML = element.outerHTML;
      }
    }

    content = pEditor.htmlFragment.innerHTML;
    pEditor.htmlFragment.innerHTML = '';
    prevContent = content;
    content = pStyle.normalizer.convertDifferentTags(content);

    if (BEditor.browser.isWebKit)
    {
      content = pStyle.normalizer.restoreWebKitHTMLInline(content);
    }

    if (args.isClearEmptyTags && reEmptyTagsReplace != null)
    {
      content = content.replace(reEmptyTagsReplace, '');
    }

    content = pEditor.contentCleaner.clearHTML(content);

    if (content !== prevContent)
    {
      isSimplify = true;
    }

    return {'htmlContent': content, 'isSimplify': isSimplify};
  };
}